import { render } from "./SendSmsPreview.vue?vue&type=template&id=024634db"
import script from "./SendSmsPreview.vue?vue&type=script&lang=js"
export * from "./SendSmsPreview.vue?vue&type=script&lang=js"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__